module.exports = __webpack_public_path__ + "img/1-3.5192cf41.jpg";